// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3OYwn","action":"styles__action___3ltK1","information":"styles__information___3qBR2","name":"styles__name___eQJP-","icon":"styles__icon___QE9tA"};